import { render, staticRenderFns } from "./SectorBtns.vue?vue&type=template&id=52405856&"
import script from "./SectorBtns.vue?vue&type=script&lang=js&"
export * from "./SectorBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports